import * as React from 'react';
import { css } from 'aphrodite';
import { styles } from './WidgetTitle.styles';

export const WidgetSectionTitle: React.FC<{ title: string }> = ({ title, children }) => {
	return (
		<div className={css(styles.nameWrapper)}>
			<div className={css(styles.sectionTitle)} title={title}>
				{title}
			</div>
			{children}
		</div>
	);
};
